import React, { FunctionComponent, useEffect, useState } from 'react';
import { Switch, Space, Typography, InputNumber } from 'antd';
import { InstagramMetadata } from '@monorepo/types';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

interface Props {
  metadata: InstagramMetadata;
  onUpdate: (metadata: Partial<InstagramMetadata>) => void;
}

const InstagramForm: FunctionComponent<Props> = ({ metadata, onUpdate }) => {
  const { t } = useTranslation();
  const [localMetadata, setLocalMetadata] =
    useState<InstagramMetadata>(metadata);

  const handleShareToFeedChange = (checked: boolean) => {
    const updated = { ...localMetadata, shareToFeed: checked };
    setLocalMetadata(updated);
    onUpdate(updated);
  };

  const handleCoverTimestampChange = (value: number | null) => {
    const updated = {
      ...localMetadata,
      coverImageTimestamp: value || undefined,
    };
    setLocalMetadata(updated);
    onUpdate(updated);
  };

  useEffect(() => {
    setLocalMetadata(metadata);
  }, [metadata]);

  return (
    <div>
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <div>
          <Title level={5} style={{ margin: '0px', marginBottom: '8px' }}>
            {t('videoEditor.socialPublish.instagram.shareToFeed')}
          </Title>
          <Space>
            <Switch
              checked={localMetadata.shareToFeed}
              onChange={handleShareToFeedChange}
            />
            <Typography.Text type="secondary">
              {localMetadata.shareToFeed
                ? t('videoEditor.socialPublish.instagram.reelInFeed')
                : t('videoEditor.socialPublish.instagram.reelOnlyReels')}
            </Typography.Text>
          </Space>
        </div>

        <div>
          <Title level={5} style={{ margin: '0px', marginBottom: '8px' }}>
            {t('videoEditor.socialPublish.instagram.coverTimestamp')}{' '}
            <Typography.Text type="secondary">
              {t('videoEditor.socialPublish.optional')}
            </Typography.Text>
          </Title>
          <InputNumber
            style={{ width: '100%' }}
            placeholder={t(
              'videoEditor.socialPublish.instagram.coverTimestampPlaceholder'
            )}
            value={localMetadata.coverImageTimestamp}
            onChange={handleCoverTimestampChange}
            min={0}
            step={1000}
            addonAfter="ms"
          />
          <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
            {t('videoEditor.socialPublish.instagram.coverTimestampHint')}
          </Typography.Text>
        </div>
      </Space>
    </div>
  );
};

export default InstagramForm;
